import React, { useEffect, useState } from 'react';
import { MdDownload } from 'react-icons/md';
import { Link } from 'react-router-dom';

import Header from '../../../layouts/Header';
import ViewVendor from '../../../features/views/vendor/Vendor';
import View from '../../../helpers/slab/View';
import BBITable from '../../../helpers/bBITable/BBITable';
import FilterData from '../../../helpers/filter/FilterData';
import Get from '../../../api/internal/Get';
import { CSVLink } from 'react-csv';
import { useOutletContext } from 'react-router-dom';
import { HiOutlineMagnifyingGlass } from 'react-icons/hi2';

function ApSummaryBoard({
  toggleBoardRefresh,
}: {
  toggleBoardRefresh: boolean;
}) {
  const [boardData, setBoardData] = useState<PayableSummaryBoardItem[]>();
  const filterValue = useOutletContext();

  useEffect(() => {
    Get(`/Accounting/GetPayableSummaryBoard/`).then(response => {
      if (response) {
        setBoardData(response.data);
      }
    });
  }, [toggleBoardRefresh]);

  const formattedBoardData = boardData?.map(boardRow => ({
    ...boardRow,
    apReport: (
      <Link to={`/reports/accountpayablereport/${boardRow.vendorId}`}>
        <HiOutlineMagnifyingGlass /> View
      </Link>
    ),
  }));

  const tableData = FilterData(formattedBoardData, filterValue);

  const DownloadCsvButton = () => {
    const csvFileName =
      new Date().toISOString().split('T')[0].replace(/[-]/g, '') +
      '_AP Summary.csv';

    const csvHeaders = columnConfig
      .filter(col => col.attribute !== 'apReport')
      .map(col => ({
        label: col.header,
        key: col.attribute,
      }));

    return (
      <button>
        <CSVLink
          data={tableData || []}
          headers={csvHeaders}
          filename={csvFileName}
        >
          <MdDownload />
          Download
        </CSVLink>
      </button>
    );
  };

  const columnConfig = [
    {
      key: '1',
      attribute: 'vendorName',
      attributeprimaryhidden: 'vendorId',
      header: 'Vendor',
      onClick: e =>
        View(
          <ViewVendor
            vendorName={e.target.innerText}
            vendorId={e.target.dataset.attributeprimaryhidden}
          />,
        ),
    },
    // {
    //   key: '2',
    //   attribute: 'apReport',
    //   attributeprimaryhidden: 'vendorId',
    //   header: 'A/P Report',
    // },
    {
      key: '3',
      attribute: 'currentTotal',
      header: 'Current',
      dataType: 'currency',
    },
    {
      key: '4',
      attribute: 'thirtyDayTotal',
      header: '30 Days',
      dataType: 'currency',
    },
    {
      key: '5',
      attribute: 'sixtyDayTotal',
      header: '60 Days',
      dataType: 'currency',
    },
    {
      key: '6',
      attribute: 'ninetyDayTotal',
      header: '90 Days',
      dataType: 'currency',
    },
    {
      key: '7',
      attribute: 'extendedTotal',
      header: '120+ Days',
      dataType: 'currency',
    },
    {
      key: '8',
      attribute: 'grandTotal',
      header: 'Total',
      dataType: 'currency',
    },
  ];

  return (
    <>
      <Header>
        <div>
          <DownloadCsvButton />
        </div>
      </Header>
      <BBITable data={tableData} columns={columnConfig} />
    </>
  );
}

export default ApSummaryBoard;
